import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { TimeSlotInfo } from '../types/reservation.types';

interface TimeSlotPillProps {
  slot: TimeSlotInfo;
  selected: boolean;
  onClick: () => void;
}

const TimeSlotPill: React.FC<TimeSlotPillProps> = ({ slot, selected, onClick }) => {
  const isDisabled = slot.status === 'full';

  return (
    <motion.button
      type="button"
      disabled={isDisabled}
      onClick={onClick}
      whileHover={!isDisabled ? { scale: 1.05 } : {}}
      whileTap={!isDisabled ? { scale: 0.95 } : {}}
      animate={selected ? { scale: [1, 1.08, 1] } : {}}
      transition={{ duration: 0.2 }}
      className={cn(
        'flex flex-col items-center justify-center rounded-xl py-3 px-2 min-w-[76px] transition-all relative',
        'focus:outline-none focus:ring-2 focus:ring-primary/50',
        isDisabled && 'opacity-50 cursor-not-allowed bg-muted border border-border',
        !isDisabled && !selected && slot.status === 'available' &&
          'bg-primary/10 border border-primary/30 text-primary hover:shadow-md',
        !isDisabled && !selected && slot.status === 'few_left' &&
          'bg-orange-500/10 border border-orange-400/40 text-orange-600 hover:shadow-md',
        selected && 'bg-primary text-primary-foreground shadow-lg border-transparent',
      )}
    >
      <span className={cn("text-sm font-bold", isDisabled && "text-muted-foreground")}>{slot.time}</span>
      {isDisabled && (
        <span className="text-[9px] mt-0.5 font-semibold text-muted-foreground uppercase tracking-wide">
          Complet
        </span>
      )}
      {slot.status === 'few_left' && !selected && (
        <span className="text-[10px] mt-0.5 font-medium">
          {slot.remainingCapacity} place{slot.remainingCapacity > 1 ? 's' : ''}
        </span>
      )}
    </motion.button>
  );
};

export default TimeSlotPill;
